import { Serializer } from "../resource/serializer.interface";
import { ContactDetails } from "./contact-details.model";

export class ContactDetailsSerializer implements Serializer {
    fromJson(json: any): ContactDetails {
        const contactDetails = new ContactDetails();
        contactDetails.id = json.id;
        contactDetails.emailAddress = json.email_address;
        contactDetails.coreContactFieldId = json.coreContactField_Id;
        contactDetails.value = json.value;
        contactDetails.tenantId = json.tenant_id;
        return contactDetails;
    }

    toJson(contactDetails: ContactDetails): any {
        return {
            id: contactDetails.id,
            email_address: contactDetails.emailAddress,
            coreContactField_Id: contactDetails.coreContactFieldId,
            value: contactDetails.value,
            tenant_id: contactDetails.tenantId
        };
    }
}
